import { reducer as formReducer } from 'redux-form'
import invoicePayment from './invoice_payment'

const reducers = {
  invoicePayment,
  form: formReducer
}

export default reducers
